import XApi from "../../utils/Api";
import XEndpoints from "../../core/config/Endpoints";

export class CustomerService {
    async create(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.customer, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }

    async update(id: number, data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.customer}/detail/${id}`, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }

    async get(id: number) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.customer}/detail/${id}`, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }

    async all() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.customer}/all`, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? [];
        }
        return [];
    }

    async download(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(`${XEndpoints.customer}/export`, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }

    async upload(file: any, data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.upload(`${XEndpoints.customer}/upload`, {
                'Authorization': `Bearer ${token}`
            }, [file], data);
            return response ?? null;
        }
        return null;
    }
    
}